import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import pointsMarkup from '../markup2/sectionJury.js';
import toolsMarkup from '../markup/tools.js';
import cropWrap from '../tools/cropWrapper.js';


const loaderSpinnerId = 'loader-enterprises';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);
const cardArbitors = document.querySelector('#Arbitors_card');
const body = document.querySelector('body');
const formAdd = body.querySelector('#modal_one_txt_one_source');
const cardArbitorsName = cardArbitors.querySelector('#Arbitors_card-name');
const cardArbitorsDesc = cardArbitors.querySelector('#Arbitors_card-desc');
const cardArbitorsAddChange = cardArbitors.querySelector('#Arbitors_card-Add-change');
const cardArbitorsAddDelete = cardArbitors.querySelector('#Arbitors_card-Add-delete');

const cardArbitorsSections = cardArbitors.querySelector('#jury_sections');
// const cardArbitorsOrders = cardArbitors.querySelector('#jury_order');
const cardArbitorsIsChairMan = cardArbitors.querySelector('#Arbitors_card-isChairman');
const cardBtMoveLeft = cardArbitors.querySelector('button[action=left]');
const cardBtMoveRight = cardArbitors.querySelector('button[action=right]');
// const cardPhotoTip = cardArbitors.querySelector('#tip');
const cardPhotoSpinner = cardArbitors.querySelector('#uploadSpinner');


const cropWrapNode1 = cardArbitors.querySelector('#image-uploader-wrapper');

let filmImageToUpload1 = null;
let filmImageToDelete1 = false;


cropWrap.init(cropWrapNode1, false, {
  // console.log();
  dataName: 'none',
  aspectRatio: 1,
  onSave: (blob) => {
    filmImageToUpload1 = blob;
    // console.log(filmImageToUpload1);
    sentPhoto();
  },
  onDelete: () => {
    filmImageToDelete1 = true;
    deletePhoto();
  }
});

// const cardArbitorsUploadNewImage = document.querySelector('#Arbitors_card_image-uploader');
// const cardArbitorsUploadNewImageElem = document.querySelector('#Arbitors_card_image-uploader-Elem');

const menuBt =  document.querySelector('#MenuJury');
let currentArbitor;
let arrayJurySections;

const mainTabPane = document.querySelector('#arbitors');
const mainTabPaneBTAdd = mainTabPane.querySelector('button[name=add]');
const mainTabPaneBTReload = mainTabPane.querySelector('button[name=refresh]');
const mainTabPaneBody = mainTabPane.querySelector('div[name=body]');

const onSuccessPointsLoad = (loadedPoints) => {
// document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedPoints.status === 200 && loadedPoints.data) {

    arrayJurySections = loadedPoints.data;
    
    removeOptions(cardArbitorsSections);
    for (let i = 0; i < arrayJurySections.length; i++) {
      let opt = document.createElement('option');
      opt.value = arrayJurySections[i].catID;
     // console.log(dataForSource.data[i].city_name);
      opt.innerHTML = arrayJurySections[i].catName;
      cardArbitorsSections.appendChild(opt);
    }
   // pointsMarkup.drawDataInContainer(loadedPoints.data);
  
      // console.log(loadedPoints);
    pointsMarkup.drawDataInContainer(loadedPoints.data);
  } else {
    pointsMarkup.cleanContainer();
    pointsMarkup.drawMarkupInContainer(`<p>Данных на сервере не обнаруженно</p>`);

  }
};

function removeOptions(selectbox) {
  for (let i = selectbox.options.length - 1; i >= 0; i--) {
    selectbox.remove(i);
  }
}

const sentPhoto = () => {
  cardPhotoSpinner.style.opacity = 1;
  // alert('fdf');
  xhr.request = {
    metod: 'POST',
    url: `jury/${cardArbitors.getAttribute('currentArbitor')}/photo/`,
    // url: `imgSaver`,
    data: filmImageToUpload1,
    callbackSuccess: (answer) => onSaveComplite(answer)
  };
};

const onSaveComplite = (answer) => {
  getPoints();
  // console.log(answer);
  if(answer && answer.data) {
    currentArbitor = parseInt(answer.data);
    cardArbitors.setAttribute('currentArbitor', currentArbitor);
  }

  cardPhotoSpinner.style.opacity = 0;
};


// cardArbitorsUploadNewImage.addEventListener('click', function () {
//   let formdata = new FormData();
//   forEach(cardArbitorsUploadNewImageElem.files, function (key, item) {
//     formdata.append(generateID(12), item);
//   });
//   // formdata.append('token', auth.data.token);

//   let xmlhttp = new XMLHttpRequest();

//   xmlhttp.onreadystatechange = function stateChanged() {
//     if (xmlhttp.readyState === 4) {
//       if (xmlhttp.status === 200) {
//         let response = JSON.parse(xmlhttp.responseText);

//         if (response.status === 200) {
//           // loading.style.display = 'none';
//           let path = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/jury/${response.data}.jpg`;
//           cardArbitorsPhoto.setAttribute('src', path);

//         } else {
//           // loading.style.display = 'none';
//           alert('Информация не обновлена, повторите попытку позже\nОшибка: ' + response.data);
//           /* if (packAdd) {
//             if (packAdd.style.display != 'block'){
//               refreshWorkSpace(lastAjaxQuery);
//             }
//           } else {
//             refreshWorkSpace(lastAjaxQuery);
//           } */
//         }
//       } else {
//         // loading.style.display = 'none';
//         alert('Error on Load User Data. Connection Error');
//         console.log('Load User Data : ' + xmlhttp.responseText);
//       }
//     }
//   };

 
//   xmlhttp.open('POST', `${window.appSettings.xhrSettings.urlApi}jury/${cardArbitors.getAttribute('currentArbitor')}/photo/`);
//   if (typeof auth.data.token !== "undefined" || auth.data.token !== 'null')
//     xmlhttp.setRequestHeader('X-Authorization', auth.data.token);
  
//   xmlhttp.send(formdata);
// });
function forEach(data, callback) {
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      callback(key, data[key]);
    }
  }
}

function generateID(length) {

  let text = '';
  let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}


mainTabPaneBTReload.addEventListener('click', function () {
  getPoints();
});

cardArbitorsAddDelete.addEventListener('click', function () {
  if(confirm('Вы точно хотите удалить жюри??? \nФотографии будут удалены с сервера.')){
    xhr.request = {
      metod: 'DELETE',
      url: `jury/${currentArbitor}`,
      data: ``,
      callbackSuccess: onSuccessAddLoad
    };
  }
});

/*
cardArbitorsPhotoUpload.addEventListener('click', function () {
  showPreview(cardArbitorsPhotoUploadPic.files[0]);
});
*/
// ================= превью картинки =================
/* const showPreview = (file) => {
  let fileName = file.name.toLowerCase();
  let fileSize = (file.size / 1024 / 1024).toFixed(2);

  if ((fileName.endsWith('jpg') || fileName.endsWith('png')) && fileSize < 5) {
    let reader = new FileReader();

    reader.addEventListener('load', function () {
      cardArbitorsPhoto.src = reader.result;
    });
    reader.readAsDataURL(file);
    let url = 'process.php';
    let formData = new FormData();
    formData.append('files[]', file);
    fetch(url, {
      method: 'POST',
      body: formData
    }).then((response) => {
      console.log(response);
    });

  } else {
    alert('Файл слишком велик, либо содержит недопустимый формат. \nИзображение должно быть формата PNG или JPG, а также не превышать размер более 5 мб. ');
  }
};
*/
cardArbitorsName.addEventListener('keyup', function (event) {
    // event.preventDefault();
    console.log(event.keyCode);
  if (event.keyCode === 13) 
  {  
    event.preventDefault();
    cardArbitorsDesc.focus();
    cardArbitorsDesc.select();

  }
});


cardBtMoveLeft.addEventListener('click', function () {
  // alert('fdf');
    xhr.request = {
      metod: 'PUT',
      url: `jury/${currentArbitor}`,
      data: `move=left`,
      callbackSuccess: getPoints
    };
});
cardBtMoveRight.addEventListener('click', function () {
  // alert('fdf');
    xhr.request = {
      metod: 'PUT',
      url: `jury/${currentArbitor}`,
      data: `move=right`,
      callbackSuccess: getPoints
    };
});


function deletePhoto() {
  xhr.request = {
    metod: 'DELETE',
    url: `jury/${currentArbitor}/photo`,
    data: '',
    callbackSuccess: cleanImg
  };
};

function cleanImg() {
  alert('очистить картинку');
  // cardArbitorsPhoto.src = 'https://cdn1.iconfinder.com/data/icons/hipster-4/512/hipster-fashion-style-beard-man-glasses-512.png';
}

mainTabPaneBTAdd.addEventListener('click', function () {
  let nameSection = prompt("Укажите, как будет называеться секция жюри:", "Жюри международного конкурса ...");
  if(nameSection){
    xhr.request = {
      metod: 'POST',
      url: `juryCategories`,
      data: `name=${nameSection}`,
      callbackSuccess: getPoints
    }
  }
});

cardArbitorsAddChange.addEventListener('click', function (evt) {
  evt.preventDefault();
  if (cardArbitors.getAttribute('currentArbitor') > 0) {
    // console.log(cardArbitors.getAttribute('currentArbitor'));
    xhr.request = {
      metod: 'PUT',
      url: `jury/${cardArbitors.getAttribute('currentArbitor')}`,
      data: `name=${cardArbitorsName.value}&desc=${cardArbitorsDesc.value}&section=${cardArbitorsSections.value}&isChairman=${cardArbitorsIsChairMan.checked}`,
      callbackSuccess: onSuccessAddLoad
    };
    /* xhr.request = {
    metod: 'PUT',
    url: `crm/user/${auth.data.operatorId}/schedule/${scheduleCELL.id}/status`,
    data: `status=0&token=${auth.data.token}`,
    callbackSuccess: onSuccessLocalNewReuest
  }; */
  } else {
    // пока без фото

    xhr.request = {
      metod: 'POST',
      url: `jury`,
      data: `name=${cardArbitorsName.value}&desc=${cardArbitorsDesc.value}&section=${cardArbitorsSections.value}&isChairman=${cardArbitorsIsChairMan.checked}`,
      callbackSuccess: onSuccessAddLoad
    };
  }

});


mainTabPaneBody.addEventListener('click', function (evt) {
  evt.preventDefault();
  console.log(evt.target.attributes.action);
  if(evt.target.attributes.action){
    let action = evt.target.attributes.action.nodeValue;
    if(action === 'delete') {
      if(confirm('Вы точно хотите удалить секцию:\n"' + evt.target.attributes.catName.nodeValue + '" ?' ))
        xhr.request = {
          metod: 'DELETE',
          url: `juryCategories/${evt.target.attributes.catId.nodeValue}`,
          data: ``,
          callbackSuccess: getPoints
        };
    } else if (action === 'rename') {
      let newName = prompt('Укажите новое название:', evt.target.attributes.catName.nodeValue);
      if (newName) {
        xhr.request = {
          metod: 'PUT',
          url: `juryCategories/${evt.target.attributes.catId.nodeValue}`,
          data: `name=${newName}&type=${action}`,
          callbackSuccess: getPoints
        };
      }
    } else if (action === 'up' || action === 'down') {
      if(confirm("Вы уверены, что хотите изменить порядок отображения секции?")) {
        xhr.request = {
          metod: 'PUT',
          url: `juryCategories/${evt.target.attributes.catId.nodeValue}`,
          data: `type=${action}`,
          callbackSuccess: getPoints
        };
      };
    } else if (action === 'new') {
      $(formAdd).modal('hide'); //Добавление жюри !!! перенести во внутрь секции!
      currentArbitor = -1;
      cardArbitors.setAttribute('currentArbitor', currentArbitor);
      cardArbitorsAddChange.innerHTML = 'Добавить';

      cardPhotoSpinner.innerHTML = loaderSpinnerMarkup;;
      cardPhotoSpinner.style.opacity = 0;
      cardArbitorsSections.value = parseInt(evt.target.attributes.catId.nodeValue, 10);
      clearCard();
      $(cardArbitors).modal('show');
    } else if (action === 'edit') {
      currentArbitor = evt.target.attributes.juryID.nodeValue;
      cardArbitors.setAttribute('currentArbitor', currentArbitor);
      clearCard();
      xhr.request = {
        metod: 'GET',
        url: `jury/${currentArbitor}`,
        data: ``,
        callbackSuccess: onSuccessCardLoad
      };
    }
  }
});


const onSuccessCardLoad = (loadedPoints) => {
// document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedPoints.status === 200) {
    $(formAdd).modal('hide');
    cardArbitorsAddChange.innerHTML = 'Изменить';

    if (loadedPoints.data.image && loadedPoints.data.image.length > 2) {
      let path = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/jury/${loadedPoints.data.image}.jpg`;
      cropWrap.setImg(cropWrapNode1, path);
      // cardArbitorsPhoto.src = path;
    }
    cardArbitorsName.value = loadedPoints.data.name;
    cardArbitorsDesc.value = loadedPoints.data.description;
    cardArbitorsSections.value = loadedPoints.data.section;
    cardArbitorsIsChairMan.checked = loadedPoints.data.isChairman;
    // cardArbitorsOrders.value = loadedPoints.data.juryOrder;
    //juryOrder 
    //juryCatID_fk]

    cardPhotoSpinner.innerHTML = loaderSpinnerMarkup;
    cardPhotoSpinner.style.opacity = 0;
    $(cardArbitors).modal('show');

  }
};
const onSuccessAddLoad = (loadedPoints) => {
// document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedPoints.status === 200) {
    getPoints();
    $(cardArbitors).modal('hide');

  }
};

function clearCard() {

  cropWrap.setImg(cropWrapNode1, 'https://cdn1.iconfinder.com/data/icons/hipster-4/512/hipster-fashion-style-beard-man-glasses-512.png');
  // cardArbitorsPhoto.src = ;
  cardArbitorsName.value = '';
  cardArbitorsDesc. value = '';

}

// function initCard() {


//   // body...
// }
const getPoints = () => {

  pointsMarkup.cleanContainer();
  pointsMarkup.drawMarkupInContainer(loaderSpinnerMarkup);

  xhr.request = {
    metod: 'GET',
    // url: `editor/operator/${auth.data.operatorId}/festival/${auth.data.currentFestival}/juryList`,
    url: `juryCategories`,
    data: ``,
    callbackSuccess: onSuccessPointsLoad
  };
};

export default {

  start() {
    menuBt.addEventListener('click', getPoints);
    // menuBt.addEventListener('click', initCard);
  },

  redraw: getPoints,

  stop() {
    pointsMarkup.cleanContainer();
    menuBt.removeEventListener('click', getPoints);
    // menuBt.removeEventListener('click', getPoints);
  }
};
